import { FC, useEffect } from "react";

import { TrainingCoursesTourSteps } from "@/features/training/pages/training-tab/TrainingCoursesTourSteps";
import { TrainingFoldersAccordion } from "@/features/training/pages/training-tab/panel-left/accordion/TrainingFoldersAccordion";
import { Box } from "@mui/material";
import { useTour } from "@reactour/tour";

export const CoursePanelLeft: FC = () => {
	const { setSteps, setCurrentStep } = useTour();

	useEffect(() => {
		setCurrentStep(0);
		if (setSteps) setSteps(TrainingCoursesTourSteps);
	}, [setSteps, setCurrentStep]);

	return (
		<Box
			sx={{
				flex: 1,
				minHeight: 0,
				display: "flex",
				flexDirection: "column",
				overflow: "hidden",
			}}
		>
			<Box
				data-tour="training-courses-folders"
				sx={{
					flex: 1,
					minHeight: 0,
					overflow: "hidden",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<TrainingFoldersAccordion />
			</Box>
		</Box>
	);
};
